// Add your custom JS here.

jQuery(document).ready(function($){
    $('.hero-slider').slick({
        arrows: true,
        dots: true,
        vertical: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    arrows: false,
                    autoplay: true
                }
            }
        ]
    });

    $('.rent-slider').slick();

    $('.space-slider').slick();
});